module.exports = __webpack_public_path__ + "static/media/internal_env_1_media_12.05af8cb1.webp";